import store from '@/store';
import logger from '@/utils/logger';
import { empConst } from '@/utils/constants';
import { getProvincias } from '@/api/provincias';
import { getDatosBancarios } from '@/api/datosBancarios';
import { removeAccentMarks } from '@/utils';

const tipoEmpresas = [
  { id: empConst.TIPO_ELE, value: 'Electricidad' },
  { id: empConst.TIPO_GAS, value: 'Gas' },
  { id: empConst.TIPO_PET, value: 'Petróleo' }
];

const catalogs = {
  state: {
    tipoEmpresas,
    datosBancarios: [],
    provincias: []
  },
  mutations: {
    SET_PROVINCIAS: (state, provincias) => {
      state.provincias = provincias;
    },
    SET_DATOSBANCARIOS: (state, datosBancarios) => {
      state.datosBancarios = datosBancarios;
    }
  },
  actions: {
    loadMaestras({ commit }) {
      if (store.getters.masterTablesLoaded) return;

      let provinciasPromise = getProvincias();

      let datosBancarios = getDatosBancarios();

      Promise.all([provinciasPromise, datosBancarios])
        .then(results => {
          commit(
            'SET_PROVINCIAS',
            results[0].data.sort((p1, p2) => {
              // p1.dsprovin.localeCompare(p2.dsprovin)
              let p1NoAcents = removeAccentMarks(p1.dsprovin.toLowerCase());
              let p2NoAcents = removeAccentMarks(p2.dsprovin.toLowerCase());
              if (p1NoAcents < p2NoAcents) return -1;
              if (p1NoAcents > p2NoAcents) return 1;
              return 0;
            })
          );
          commit('SET_MASTER_TABLES_LOADED', true);
          commit('SET_DATOSBANCARIOS', results[1].data);
        })
        .catch(error => {
          logger.print(error);
        });
    }
  }
};

export default catalogs;
